import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { Box, Button } from '@mui/material';
import { palette } from 'theme/palette';
import { setAccountSelectedProduct } from 'reducers/accountReducer';
import { selectAccountNumber, selectSelectedAccountTableItem } from 'selectors/accountSelector';
import { videoIdentificationStyles } from 'views/VideoIdentification/VideoIdentificationFormActions';

export const IndexBalancedActions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const accountNumber = useSelector(selectAccountNumber);
  const selectedProduct = useSelector(selectSelectedAccountTableItem);

  const handleCancel = () => {
    dispatch(setAccountSelectedProduct(undefined));
    navigate(`/accounts?accountNumber=${accountNumber}`);
  };

  const proposeChangeAction = () => {
    navigate(`/accounts/${accountNumber}/product/${selectedProduct}/change`);
  };

  return (
    <Box sx={videoIdentificationStyles.actions}>
      <Box
        style={{
          width: '95%',
          display: 'flex',
          justifyContent: 'space-between',
          maxWidth: '95%',
        }}
      >
        <Button
          id="cancel-index-balanced-button"
          data-testid="cancel-index-balanced-button"
          onClick={handleCancel}
          variant="outlined"
          style={{ color: palette.black }}
        >
          Cancel
        </Button>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            style={{ marginRight: 0 }}
            id="propose-change-button"
            data-testid="propose-change-button"
            variant="contained"
            onClick={proposeChangeAction}
            color="primary"
          >
            Propose change
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
